import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`DS: Data Science & Machine Learning`}</h1>
    <p>{`In the `}<em parentName="p">{`Data Science Concentration`}</em>{` students will learn data analysis, data visualization and
extracting statistical information into a dataset. Students will also learn how to predict a
continuous target for example stock market price based on various features in a tabular data, they
will explore methods that can be used to cluster datasets into groups. Other topics include
classification of different data resources including image, text and audio by using neural networks
and deep learning, approaches to deploy machine learning models in the cloud using Flask, Docker,
and advanced applications of machine learning and deep learning for recommender systems, natural
language processing and computer vision.`}</p>
    <p><strong parentName="p">{`DS 1.0 - Data Exploration and Visualization (ACS 2500) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: CS 1.11, MATH 1450, ALEKS`}</em></p>
    <p>{`In this course students will develop the ability to apply quantitative reasoning to interpret,
analyze, and explain data. Students will learn to use modern software libraries to ingest, clean,
explore, transform, manipulate, summarize and visualize data sets. Students will gain facility with
the art of data visualization to tell stories and use data-driven insights to persuade decision
makers.`}</p>
    <p><strong parentName="p">{`DS 1.11 - Introduction to Data Science Workflow (ACS 2511) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: DS 1.0`}</em></p>
    <p>{`In this course, students will learn the end to end data science workflow process including
collecting, cleaning, exploring and visualizing data, followed by pre-processing the data, modeling
the data, and evaluating the model. Students will implement the data science workflow process on
simple regression and classification models using pandas, matplotlib and scikit-learn. Students will
utilize statistical techniques and become fluent in the science and art of data exploration and
visualization to tell stories and persuade decision makers with data-driven insights.`}</p>
    <p><strong parentName="p">{`DS 2.1 - Machine Learning (ACS 3510) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: DS 1.1`}</em></p>
    <p>{`This course explores the foundations of modern machine learning algorithms and their practical
application to solving data science problems. The course covers supervised learning techniques
including decision trees, naive Bayes, k-nearest neighbors, linear and logistic regression, support
vector machines, and ensemble methods including random forests and gradient boosting. The course
will also cover unsupervised learning techniques including k-means, principal components analysis
and hierarchical clustering. Students learn to use industry-standard modern software libraries and
tools to solve a variety of data science problems via an “end-to-end” approach, building pipelines
to ingest, clean, preprocess and transform data sets, and train, evaluate and fine-tune models.`}</p>
    <p><strong parentName="p">{`DS 2.2 - Deep Learning (ACS 3520) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: DS 1.11`}</em></p>
    <p>{`This course provides an introduction to deep learning. Students will learn a series of neural
network architectures including the perceptron, fully connected deep neural networks and
convolutional neural networks. Students will construct their own simple feed-forward neural network
from scratch and learn to train it via backpropagation using gradient descent. The course will cover
the use of industry standard libraries to create and fine-tune sophisticated neural network models,
and to build end-to-end data processing pipelines to train the models.`}</p>
    <p><strong parentName="p">{`DS 2.3 - Data Science in Production (ACS 3530) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: WEB 1.1, DS 2.1, DS 2.2`}</em></p>
    <p>{`This course covers the tools and techniques commonly utilized for production machine learning in
industry. Students learn how to provide web interfaces for training machine learning or deep
learning models. Students will deploy models on the web and in the cloud, gather and process data
from the web, and display information for consumption using advanced web applications. Students
learn to use data processing frameworks that allow them to access large datasets on the cloud and to
perform processing tasks on that data using distributed computing.`}</p>
    <p><strong parentName="p">{`DS 2.4 - Core Applications of Artificial Intelligence (ACS 4511) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: DS 2.1, DS 2.2`}</em></p>
    <p>{`This course covers key applications of artificial intelligence in data science. Students will learn
to solve computer vision problems across a variety of applications including object detection, image
segmentation and image classification. Students will also learn to apply anomaly detection models
and to build recommender systems. Students complete individual projects in one of the topic areas
and present their findings to the class.`}</p>
    <p><strong parentName="p">{`DS 2.5 - Natural Language Processing (ACS 4520) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: DS 2.1, DS 2.2`}</em></p>
    <p>{`This course introduces methods of Natural Language Processing (NLP), and their applications to
sequential data. Key topics covered include RNNs, Sequence models, and Language Models, and advanced
concepts such as Attention and the BERT architecture. Students will learn to apply language models
to a variety of tasks across NLP, such as Sentiment analysis, Neural Machine Translation, Question
Answering and Text Summarization. Students complete individual projects in one of the topic areas
and present their findings to the class.`}</p>
    <p><strong parentName="p">{`DS 2.9 - Data Science Technical Seminar (ACS 4590) `}<em parentName="strong">{`3 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: 6 Upper Division Credits in Seminar Concentration, Instructor Approval`}</em></p>
    <p>{`This is an advanced course with industry relevant topics suggested by students within a
concentration. Courses are in seminar format and will often be led by students. Instructor will
provide support in determining topics and adding insight to discussions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      